import React from 'react';

import {
  Button,
} from '@mui/material';
import { useSelector } from 'react-redux';

import AddChild from './AddChild';
import ChildInfo from './ChildInfo';
import * as selectorsChild from './selector';

import type { UserAttributes } from '@/infra/cognitoIApi';
import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { FacilityJson } from '@/types/domain/childApply/entities/facilityEntity';

import Title from '@/components/Title';

/**
 * プロパティ
 */
export type Props = {
  /** 子ども */
  child: ChildJson | undefined,
  /** ユーザー名 */
  username: string,
  /** 属性 */
  attrs: UserAttributes,
  /** 施設リスト */
  facilityList: FacilityJson[],
};

const ChildList: React.FC<Props> = ({
  child,
  username,
  attrs,
  facilityList,
}) => {
  // 値取得
  const childList = useSelector(selectorsChild.childListSelector);
  // メイン処理
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <div>
      <Title title="子ども情報" />
      <div>
        {childList.length === 0 && (
          <div style={{ marginBottom: '10px' }}>
            子どもが登録されていません。新規登録を行ってください。
          </div>
        )}
        <Button
          variant="contained"
          color="primary"
          onClick={() => setIsOpen(true)}
        >
          新規登録
        </Button>
      </div>
      {child && (
        <ChildInfo
          child={child}
          childFacilityList={facilityList}
        />
      )}
      <AddChild
        isOpen={isOpen}
        setIsOpen={(open) => setIsOpen(open)}
        parentId={username}
        familyName={attrs.familyName}
        familyNameKana={attrs.familyNameKana}
      />
    </div>
  );
};

export default ChildList;
